<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-lg">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0 font-weight-bold">Crear Nuevo Usuario / Colaborador</p>
                        </div>
                    </div>

                    <div class="card-body">
                        <div v-if="isLoading" class="text-center py-5">
                            <div class="spinner-border text-success" role="status"></div>
                            <p class="mt-2 text-sm text-secondary">Cargando dependencias...</p>
                        </div>

                        <form v-else @submit.prevent="submitUser">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre Completo</label>
                                    <argon-input v-model="user.full_name" type="text" placeholder="Ej: Juan Pérez" />
                                    <small v-if="submitted && v$.user.full_name.$error" class="text-danger">Requerido.</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-control-label">Documento de Identidad (DUI/Cédula)</label>
                                    <argon-input v-model="user.document" type="text" placeholder="001-000000-0000U" />
                                    <small v-if="submitted && v$.user.document.$error" class="text-danger">Documento requerido.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Nombre de Usuario (Login)</label>
                                    <argon-input v-model="user.username" type="text" placeholder="juan.perez" />
                                    <small v-if="submitted && v$.user.username.$error" class="text-danger">Username requerido.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Correo Electrónico</label>
                                    <argon-input v-model="user.email" type="email" placeholder="email@dominio.com" />
                                    <small v-if="submitted && v$.user.email.$error" class="text-danger">Email válido requerido.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Rol del Sistema</label>
                                    <select class="form-control" v-model.number="user.role_id">
                                        <option :value="null">Seleccione un rol</option>
                                        <option v-for="role in roles" :key="role.id" :value="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <small v-if="submitted && v$.user.role_id.$error" class="text-danger">Rol requerido.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Sucursal Asignada</label>
                                    <select class="form-control" v-model.number="user.fk_branch_id" :disabled="userRole === 2">
                                        <option :value="null">Seleccione una sucursal</option>
                                        <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                            {{ branch.name }}
                                        </option>
                                    </select>
                                    <small v-if="submitted && v$.user.fk_branch_id.$error" class="text-danger">Sucursal requerida.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Contraseña Inicial</label>
                                    <argon-input v-model="user.password" type="password" placeholder="Mínimo 6-8 caracteres" />
                                    <small v-if="submitted && v$.user.password.$error" class="text-danger">Contraseña requerida.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Estado de Cuenta</label>
                                    <div class="form-check form-switch mt-2">
                                        <input class="form-check-input" type="checkbox" id="isActiveSwitch" v-model="user.is_active" :true-value="1" :false-value="0">
                                        <label class="form-check-label" for="isActiveSwitch">{{ user.is_active === 1 ? 'Cuenta Activa' : 'Cuenta Suspendida' }}</label>
                                    </div>
                                </div>
                            </div>

                            <argon-button
                                type="submit"
                                class="mt-5"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Guardar Usuario
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';

export default {
    name: "CreateUser",
    components: { ArgonInput, ArgonButton },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        const companyId = localStorage.getItem('companyId');
        return {
            isLoading: true,
            submitted: false,
            roles: [],
            branches: [], // Almacenará las sucursales
            user: {
                username: '',
                email: '',
                document: '', // NUEVO
                role_id: null,
                fk_branch_id: null, // NUEVO
                full_name: '',
                is_active: 1,
                company: parseInt(companyId),
                password: '',
            },
            branchId:parseInt(localStorage.getItem('branchId')),
            userRole:parseInt(localStorage.getItem('userLevel'))
        };
    },
    validations() {
        return {
            user: {
                full_name: { required: helpers.withMessage('Requerido', required) },
                username: { required: helpers.withMessage('Requerido', required) },
                document: { required: helpers.withMessage('Requerido', required) },
                email: {
                    required: helpers.withMessage('Requerido', required),
                    email: helpers.withMessage('Email inválido', email)
                },
                role_id: { required: helpers.withMessage('Rol requerido', required) },
                fk_branch_id: { required: helpers.withMessage('Sucursal requerida', required) },
                password: { required: helpers.withMessage('Contraseña requerida', required) },
            },

        };
    },
    mounted() {
        this.fetchDependencies();
    },
    methods: {
        async fetchDependencies() {
            this.isLoading = true;
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };
            const apiURL = this.$store.state.apiURL;

            try {
                // Cargamos Roles y Sucursales en paralelo
                const [rolesRes, branchesRes] = await Promise.all([
                    axios.get(`${apiURL}roles`, config),
                    axios.get(`${apiURL}branches?company=${this.user.company}`, config)
                ]);

                this.roles = rolesRes.data;
                this.branches = branchesRes.data;

                if(this.userRole==2){
                    this.user.fk_branch_id=this.branchId
                    this.branches= this.branches.filter(x=> x.id==this.branchId);
                    this.roles=this.roles.filter(x=> x.id>1);
                }
            } catch (error) {
                console.error("Error al cargar dependencias:", error);
                this.handleSessionError(error);
            } finally {
                this.isLoading = false;
            }
        },

        async submitUser() {
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) {
                Swal.fire({ title: 'Datos incompletos', text: 'Por favor, llena todos los campos obligatorios.', icon: 'warning' });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };

            try {
                await axios.post(`${this.$store.state.apiURL}users`, this.user, config);

                Swal.fire({
                    title: '¡Éxito!',
                    text: `Usuario ${this.user.username} creado exitosamente.`,
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                }).then(() => {
                    this.$router.push('/settings/users');
                });

            } catch (err) {
                const msg = err.response?.data?.message || 'Error al crear el usuario. El username o documento podrían estar duplicados.';
                Swal.fire({ title: 'Error', text: msg, icon: 'error' });
            }
        },

        handleSessionError(error) {
            if (error.response?.status === 401) {
                Swal.fire('Sesión Expirada', 'Por favor ingresa de nuevo.', 'info').then(() => {
                    this.$router.push('/signin');
                });
            }
        }
    },
};
</script>